















import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import WebApiSettingProfile from '@/components/organisms/WebApiSettingProfile.vue';
import { ConversionApiClientInfo } from '@/types/type';

@Component({
  components: {
    WebApiSettingProfile,
  },
})
export default class WebApiSettingBody extends Vue {
  @Prop()
  private loading!: boolean;
  @Prop()
  private clientId!: string;
  @Prop()
  private clientSecret!: string;
  @Prop()
  private clientInfoExists!: boolean;

  @Emit('create-conversion-api-client-info')
  private createConversionApiClientInfo(clientInfo: ConversionApiClientInfo) {
    return clientInfo;
  }

  @Emit('delete-conversion-api-client-info')
  private deleteConversionApiClientInfo() {}
}
